/**
 * Password Change Modal
 * Voluntary password change from Profile > Security
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Lock } from 'lucide-react'
import { PasswordChangeForm } from './PasswordChangeForm'

interface PasswordChangeModalProps {
  open: boolean
  onClose: () => void
}

export function PasswordChangeModal({ open, onClose }: PasswordChangeModalProps) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-primary">
            <Lock className="h-5 w-5" />
            Change Password
          </DialogTitle>
          <DialogDescription>
            Enter your current password and choose a new secure password
          </DialogDescription>
        </DialogHeader>

        <PasswordChangeForm onSuccess={onClose} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  )
}

export default PasswordChangeModal
